const WasteManagementAccompanyNoteSubcategory = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2906_12068)" />
    <g clip-path="url(#clip0_2906_12068)">
      <path d="M42.9653 23V30.9974H50.9706L42.9653 23Z" fill="white" />
      <path
        d="M42.9655 33.0165C41.8728 33.0165 40.9542 32.098 41.0097 30.9419V23H22.0219C20.3511 23 19.0288 24.3223 19.0288 25.9931V44.0069C19.0288 45.6777 20.3511 47 22.0219 47H47.9777C49.6484 47 50.9707 45.6777 50.9707 44.0069V33.0165H42.9734H42.9655ZM24.9833 29.0416H34.9998C35.5145 29.0416 35.9816 29.4454 35.9816 30.0234C35.9816 30.5381 35.5778 31.0053 34.9998 31.0053H24.9833C24.4686 31.0053 24.0014 30.6015 24.0014 30.0234C24.0014 29.5087 24.4607 29.0416 24.9833 29.0416ZM45.1509 42.6846H24.9041C24.3261 42.6846 23.8668 42.2808 23.8668 41.7027C23.8668 41.1881 24.2706 40.7209 24.8487 40.7209H45.1588C45.6735 40.7209 46.1407 41.1247 46.1407 41.7027C46.1407 42.2174 45.7368 42.6846 45.1588 42.6846H45.1509ZM45.1509 38.7176H24.9041C24.3261 38.7176 23.8668 38.2583 23.8668 37.7357C23.8668 37.2131 24.2706 36.7539 24.8487 36.7539H45.1588C45.6735 36.7539 46.1407 37.1577 46.1407 37.7357C46.1407 38.2504 45.7368 38.7176 45.1588 38.7176H45.1509Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2906_12068"
        x1="-1.56654e-06"
        y1="4.96155"
        x2="70"
        y2="66.9615"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E5A100" />
        <stop offset="1" stop-color="#F14B12" />
      </linearGradient>
      <clipPath id="clip0_2906_12068">
        <rect width="31.9419" height="24" fill="white" transform="translate(19.0288 23)" />
      </clipPath>
    </defs>
  </svg>
)

export default WasteManagementAccompanyNoteSubcategory
